"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
/** renamed export of isNonNaNNumber from types, tests that is number, ie not NaN, undefined or null */
exports.isNumber = iotv_v3_types_1.isNonNaNNumber;
